import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionDateOfAccidentAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`dateOfAccident-${sessionId}`, null as Date | null)
);
export const dateOfAccidentAtom = createDerivedSessionAtom<Date | null>(sessionDateOfAccidentAtom);

export const sessionTimeOfAccidentAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`timeOfAccident-${sessionId}`, null as Date | null)
);
export const timeOfAccidentAtom = createDerivedSessionAtom<Date | null>(sessionTimeOfAccidentAtom);
